// src/utils/fbError.js
export function parseFirebaseError(err) {
  const isFB = err && (err.name === "FirebaseError" || err.code?.includes("/"));
  const code = isFB ? err.code : "unknown";
  const msg = err?.message || String(err);
  // Common codes: 'permission-denied', 'unauthenticated', 'not-found', 'failed-precondition', etc.
  return { isFB, code, msg, raw: err };
}

export function logFirebaseError(context, err, extra = {}) {
  const { isFB, code, msg, raw } = parseFirebaseError(err);
  // Grouped + readable
  console.groupCollapsed(`🔥 FirebaseError @ ${context} ${code ? `(${code})` : ""}`);
  console.log("Message:", msg);
  if (isFB) console.log("Code:", code);
  if (Object.keys(extra).length) console.log("Extra:", extra);
  console.log("Stack:", raw?.stack || raw);
  console.groupEnd();
}

export function isPermissionDenied(err) {
  return parseFirebaseError(err).code === "permission-denied";
}
